function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36.53,
    height: 18.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.35875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 9.435,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.87,
    width: 36.53,
    height: 33.07,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.614
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 35.405,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.95,
    width: 36.53,
    height: 35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 69.45,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.95,
    width: 36.53,
    height: 42.02,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.1325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 107.96000000000001,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.97,
    width: 36.53,
    height: 42.09,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.088333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 150.015,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 171.06,
    width: 36.53,
    height: 42.87,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.306
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 192.495,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 213.93,
    width: 36.53,
    height: 43.24,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.088333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 235.55,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.16,
    width: 36.53,
    height: 50.38,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.218571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 282.35,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 307.55,
    width: 36.53,
    height: 56.73,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.058888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 335.915,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.28,
    width: 36.53,
    height: 58.31,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 393.43499999999995,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 422.59,
    width: 36.53,
    height: 63.91,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.218571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 454.54499999999996,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 486.5,
    width: 36.53,
    height: 67.96,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 520.48,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 554.47,
    width: 36.53,
    height: 72.14,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 590.5400000000001,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 626.61,
    width: 36.53,
    height: 73.39,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.265,
    y: 663.3050000000001,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 0,
    width: 48.97,
    height: 56.06,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.161666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.015,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.49,
    y: 0,
    width: 50.94,
    height: 56.06,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.277142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.96,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.43,
    y: 0,
    width: 50.98,
    height: 56.06,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.92000000000002,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.41,
    y: 0,
    width: 51.36,
    height: 56.06,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.09,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.77,
    y: 0,
    width: 52.46,
    height: 56.06,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.494285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.23,
    y: 0,
    width: 53.59,
    height: 56.06,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.655714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.02500000000003,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.82,
    y: 0,
    width: 55.19,
    height: 56.06,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.519
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.41499999999996,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.01,
    y: 0,
    width: 55.58,
    height: 56.06,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.8,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.59,
    y: 0,
    width: 55.62,
    height: 56.06,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.4,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.21,
    y: 0,
    width: 58.82,
    height: 56.06,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.62,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.03,
    y: 0,
    width: 64.08,
    height: 56.06,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.0699999999999,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.11,
    y: 0,
    width: 65.89,
    height: 56.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.0550000000001,
    y: 28.03,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 56.06,
    width: 66.48,
    height: 58.42,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3109090909090915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 85.27000000000001,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 114.48,
    width: 66.48,
    height: 59.66,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.943333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 144.31,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 174.13,
    width: 66.48,
    height: 60.65,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 204.45499999999998,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 234.78,
    width: 66.48,
    height: 61.4,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.77142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 265.48,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 296.18,
    width: 66.48,
    height: 62.67,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.83375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 327.515,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 358.85,
    width: 66.48,
    height: 65.17,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 391.435,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 424.02,
    width: 66.48,
    height: 67.49,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.386666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 457.765,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 491.51,
    width: 66.48,
    height: 67.81,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 525.415,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 559.32,
    width: 66.48,
    height: 69.4,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 594.0200000000001,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.53,
    y: 628.72,
    width: 66.48,
    height: 71.28,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.648000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.77000000000001,
    y: 664.36,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 56.06,
    width: 68.59,
    height: 69.78,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.29500000000002,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.59,
    y: 56.06,
    width: 69.57,
    height: 69.78,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.913999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.375,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.16,
    y: 56.06,
    width: 73.31,
    height: 69.78,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.815,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.48,
    y: 56.06,
    width: 74.87,
    height: 69.78,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.968571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.915,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.35,
    y: 56.06,
    width: 75,
    height: 69.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.85,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.35,
    y: 56.06,
    width: 75.77,
    height: 69.78,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.235,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.12,
    y: 56.06,
    width: 76.66,
    height: 69.78,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.45,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.78,
    y: 56.06,
    width: 83.22,
    height: 69.78,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.39,
    y: 90.95,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 125.84,
    width: 77.48,
    height: 75.29,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.058000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 163.485,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 201.13,
    width: 77.48,
    height: 77.32,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.045714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 239.79,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 278.45,
    width: 77.48,
    height: 81.09,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.06857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 318.995,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 359.53,
    width: 77.48,
    height: 83.13,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 401.09499999999997,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 442.66,
    width: 77.48,
    height: 83.36,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.748
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 484.34000000000003,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 526.02,
    width: 77.48,
    height: 86.06,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 569.05,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 612.08,
    width: 77.48,
    height: 87.92,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.74,
    y: 656.0400000000001,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 125.84,
    width: 76.43,
    height: 93.85,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.55375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.695,
    y: 172.765,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.91,
    y: 125.84,
    width: 81.22,
    height: 93.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.52000000000004,
    y: 172.765,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.13,
    y: 125.84,
    width: 84.52,
    height: 93.85,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.39111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.39,
    y: 172.765,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.64,
    y: 125.84,
    width: 87.98,
    height: 93.85,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.596
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.63,
    y: 172.765,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.63,
    y: 125.84,
    width: 93.38,
    height: 93.85,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.3199999999999,
    y: 172.765,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.01,
    y: 125.84,
    width: 95.99,
    height: 93.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.73125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.005,
    y: 172.765,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 219.69,
    width: 106.49,
    height: 89.44,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.937777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.725,
    y: 264.40999999999997,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 309.13,
    width: 106.49,
    height: 92.87,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.574
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.725,
    y: 355.565,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 402,
    width: 106.49,
    height: 96.57,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.729999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.725,
    y: 450.28499999999997,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 498.57,
    width: 106.49,
    height: 99.38,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.042222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.725,
    y: 548.26,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 597.95,
    width: 106.49,
    height: 102.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.578571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.725,
    y: 648.975,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.98,
    y: 219.69,
    width: 98.78,
    height: 112.61,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.3475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.37,
    y: 275.995,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.76,
    y: 219.69,
    width: 103.92,
    height: 112.61,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.784
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.71999999999997,
    y: 275.995,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.68,
    y: 219.69,
    width: 104.44,
    height: 112.61,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.604444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.9,
    y: 275.995,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.12,
    y: 219.69,
    width: 105.88,
    height: 112.61,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.625454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.06,
    y: 275.995,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.98,
    y: 332.3,
    width: 116.28,
    height: 115.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.851111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.12,
    y: 390.13,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.98,
    y: 447.96,
    width: 116.28,
    height: 121.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.12,
    y: 508.905,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.98,
    y: 569.85,
    width: 116.28,
    height: 130.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.12,
    y: 634.9250000000001,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.25,
    y: 332.3,
    width: 296.75,
    height: 77,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.625,
    y: 370.8,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.25,
    y: 409.3,
    width: 296.75,
    height: 290.7,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.625,
    y: 554.65,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.3dcf6d1ecda35c07ba6002cdb3e8ef74.svg";
export { ForwardRef as ReactComponent };